/**
 * Кто имеет право запретить автоперезагрузку.
 *
 * Перезагрузка после падения чанка выглядит бесплатной, но она уничтожает всё несохранённое
 * состояние вкладки. Иногда цена выше пользы: оборвать активный звонок ради того, чтобы человек
 * увидел свежую сборку, — плохой размен, честный экран ошибки лучше.
 *
 * Реестр, а не прямой импорт стора, специально: `chunkReload` лежит на пути обработки любой
 * ошибки, и тянуть в него звонки (а за ними LiveKit) нельзя. Заинтересованная фича регистрирует
 * себя сама и только тогда, когда её модуль вообще загружен.
 */

type ReloadBlocker = () => boolean;

const blockers = new Set<ReloadBlocker>();

/** Возвращает функцию отписки. */
export const registerReloadBlocker = (blocker: ReloadBlocker): (() => void) => {
  blockers.add(blocker);

  return () => {
    blockers.delete(blocker);
  };
};

export const isReloadBlocked = (): boolean => {
  for (const blocker of blockers) {
    try {
      if (blocker()) {
        return true;
      }
    } catch {
      // Сломанный блокировщик не должен запрещать восстановление.
    }
  }

  return false;
};

/** Только для тестов: реестр живёт в модуле и переживает отдельные кейсы. */
export const clearReloadBlockers = () => {
  blockers.clear();
};
